<template>
  <div>
    <div class="modal fade" id="edit-address" tabindex="-1"
         aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">


            <address-form :address-id="form.address" :address-name="addressName"
                          :addresses-object="component_addresses"
                          :submit-function="editAddress"/>


          </div>
        </div>
      </div>
    </div>
    <m-shopping-cart-wrapper @order="setOrderDescription" @address="setAddresses">
      <template v-slot="{order,products,deliveryPrice,deliveryBoundary,freeCities,payDescript,addresses}">
        <div class="container my-5">

          <div class="" v-if="products.length > 0">

            <button class="mx-1 btn btn-primary rounded-pill" @click="reloadShoppingCart()">
              <i class="bi bi-arrow-repeat"/>
              {{ $t('shopping_cart_general.refresh_shopping_cart') }}
            </button>

            <m-a :href="setWalletLinkToDashboard" v-if="showWalletChargeProp" target="_blank">
              <button class="mx-1 btn btn-secondary rounded-pill">
                <i class="bi bi-wallet2"/>
                {{ $t('shopping_cart_general.wallet_value') }}:
                {{ profileWalletValue }}
              </button>
            </m-a>

            <span v-if="enableEditOrder && (isAdmin || isUserStore)" @click="redirectUserToEditOrder(order)"
                  class="btn btn-primary rounded-pill">ویرایش سفارش</span>


            <form @submit.prevent="onSubmit(order)">
              <div class="row">
                <div class="col-lg-5 col-md-5 d-inline-block" v-for="item in products" :key="item.id">
                  <m-card304 class="col-lg-12 my-1" :image="productImage(item.product,item.sub_product)"
                             :alt="item.product.name">
                    <template #p-1>
                      <m-a class="text-decoration" :href="{name:'Product',params:{name:item.product.raw_link}}">
                        <h5>{{ productName(item.product, item.sub_product) }}</h5>
                      </m-a>

                      <div v-if="item.product.variation == 2">

                        <div class="">
                          <p>{{
                              dateConverter(productReservationRange(item)['min'], '/', true)
                            }}</p>
                          <p>{{
                              dateConverter(productReservationRange(item)['max'], '/', true)
                            }}</p>
                        </div>

                        <div class="">
                          <p v-for="(value,key) in reservationMetaTranslation(item)">{{ key }} : {{ value }}</p>
                        </div>

                      </div>

                      <div>
                        <div class="" v-if="item.offer_on_product > 0">
                          <del><span v-html="$t('price.price',{currency:formatNumber(item.price)})"></span></del>
                          <span class="badge badge-primary rounded-pill"
                                v-html="$t('price.offer',{currency:formatNumber(item.offer_on_product)})">
                        </span>
                          <br>

                        </div>
                        <span
                            v-html="$t('price.price',{currency:formatNumber(item.price-item.offer_on_product)})"></span>
                      </div>

                    </template>
                    <template #p-2>
                      <m-shopping-cart-quantity-manager1 :product="item.product"
                                                         :sub_product="item.sub_product"/>
                    </template>
                  </m-card304>

                </div>
              </div>

              <div class="row">

                <div class=" col-lg-3 my-3">

                  <div class="bg-white py-1 col-lg-12 shopping-cart-box">
                    <p class="custom-font-size shopping-cart-total">
                      <span v-t="'shopping_cart_general.total'"></span>
                      <span class="mx-1"
                            v-html="$t('price.price', {currency: formatNumber(order.total_amount)})"> </span>
                    </p>
                    <p class="custom-font-size shopping-cart-offer">
                      <span v-t="'shopping_cart_general.offer'"></span>
                      <span class="mx-1"
                            v-html="$t('price.price', {currency: formatNumber(order.offer_amount)})"> </span>
                    </p>

                    <div class="custom-font-size shopping-cart-delivery-price"
                         :class="{'line-through':isDeliveryFree(deliveryBoundary,order.total_amount)}">
                      <p>
                        <span v-t="'shopping_cart_general.delivery_price'"></span>
                        <span class="mx-1" v-html="deliveryPriceManager(deliveryPrice)"></span>
                      </p>
                    </div>

                    <div class="custom-font-size shopping-cart-tax">
                      <p>
                        <span v-t="'shopping_cart_general.tax'"></span>
                        <span class="mx-1"
                              v-html="$t('price.price', {currency: formatNumber(calculateTax(order))})"></span>
                      </p>
                    </div>

                    <p class="font-weight-bolder shopping-cart-paying-amount">

                      <span v-t="'shopping_cart_general.paying_amount'"></span>
                      <span class="mx-1"
                            v-html="$t('price.price', {currency: formatNumber(order.paying_amount)})"></span>
                    </p>

                  </div>
                  <div class="shopping-cart-paying-delivery-boundary">
                    <p class="text-muted delivery-boundary-font-size ">
                      <span v-t="'shopping_cart_general.free_delivery_amount'"></span>
                      <span class="mx-1"
                            v-html="$t('price.price', {currency: formatNumber(deliveryBoundary)})"></span>
                    </p>

                    <div class="mt-3 free-delivery-cities" v-if="freeCities.length > 0">
                      <span v-t="'shopping_cart_general.free_delivery_cities'"></span>
                      <span class=" mx-2 text-success" v-for="city in freeCities">
                {{ city.value.province.name }}-{{ city.value.name }}
                </span>
                    </div>
                  </div>

                </div>
                <div class="col-lg-3 my-3">
                  <div class="bg-white  h-100 py-1 col-lg-12 shopping-cart-box">
                    <p v-t="'shopping_cart_general.description'"></p>
                    <span class="order-description"
                          v-t="'shopping_cart_general.description_on_payment_page'"></span>
                  </div>
                </div>
                <div class="col-lg-6 shopping-cart-3-address-section my-3" v-if="orderHavePhysicalProduct(order)">
                  <div class="bg-white  h-100 py-1 col-lg-12 shopping-cart-box">
                    <span v-t="'address.address'"></span>

                    <button
                        class="btn btn-sm btn-primary rounded-pill float-left d-flex align-items-center shopping-card-3-address-button "
                        type="button"
                        data-toggle="modal"
                        data-target="#create-address">
                      <span v-t="`shopping_cart_general.create_address_button_text`"></span>
                      <i class="bi bi-plus-circle mx-1"></i>

                    </button>


                    <div class="modal fade" id="create-address" tabindex="-1"
                         aria-labelledby="create-address"
                         aria-hidden="true">
                      <div class="modal-dialog modal-lg">
                        <div class="modal-content">
                          <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal"
                                    aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">

                            <address-form :address-name="addressName" :submit-function="createAddress"/>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="form-group mt-3">
                      <div class="d-flex align-items-center">
                        <select v-model="form.address" class="form-control" @change="changeAddress(order)"
                                style="flex: 9;">
                          <option value=""
                                  v-t="`shopping_cart_general.choose_address_select_box_default_text`"></option>
                          <option v-for="address in component_addresses" :value="address.value">
                            {{ address.text }}
                          </option>
                        </select>

                        <i v-if="form.address && selectedAddressNotBeDefault()"
                           data-toggle="modal"
                           data-target="#edit-address"
                           class="bi bi-pen-fill ml-2" style="flex: 1; text-align: center;"></i>
                      </div>

                      <form-errors-manager :validation="v$.form.address"/>
                    </div>


                    <div class="form-group">


                      <m-advance-description1
                          v-if="advanceDescription"
                          :inputsConfig="advanceDescriptionInputs"
                          v-model="form.order_description"
                          description=""
                          item-class="col-lg-6 my-2"
                      />

                      <textarea v-else
                                class="form-control my-4"
                                :placeholder="$t('shopping_cart_general.order_description')"
                                rows="3"
                                max-rows="3"
                                v-model="form.order_description"
                                id="textarea"/>


                      <form-errors-manager :validation="v$.form.order_description"/>
                    </div>

                    <div class="form-group">
                      <textarea class="form-control my-4"
                                :placeholder="$t('shopping_cart_general.presenter')"
                                rows="3"
                                max-rows="3"
                                v-if="presenterProp"
                                v-model="form.presenter"
                                id="textarea"></textarea>
                      <form-errors-manager :validation="v$.form.presenter"/>
                    </div>

                    <div class="form-group">
                      <input type="text" class="my-4 form-control" v-if="instagram"
                             v-model="form.instagram"
                             :placeholder="$t('shopping_cart_general.instagram')">
                      <form-errors-manager :validation="v$.form.instagram"/>
                    </div>


                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="bg-white shopping-cart-box">
                    <div class="form-row">

                      <div class="p-3 col-lg-4" v-if="codeMeliProp">
                        <input class="form-control text-left" required dir="ltr" type="text" v-model="form.code_meli"
                               :placeholder="$t('authentication_general.code_meli')">
                      </div>

                      <div class="p-3 col-lg-4" v-if="gradeProp">
                        <input class="form-control " required type="text" v-model="form.grade"
                               :placeholder="$t('authentication_general.grade')">
                      </div>

                      <div class="p-3 col-lg-4" v-if="orientationProp">
                        <input class="form-control " required type="text" v-model="form.orientation"
                               :placeholder="$t('authentication_general.orientation')">
                      </div>

                      <div class="p-3 col-lg-6" v-if="schoolNameProp">
                        <input class="form-control " required type="text" v-model="form.school_name"
                               :placeholder="$t('authentication_general.school_name')">
                      </div>

                      <div class="p-3 col-lg-6" v-if="classNameProp">
                        <input class="form-control " required type="text" v-model="form.class_name"
                               :placeholder="$t('authentication_general.class_name')">
                      </div>

                      <div class="p-3 col-lg-4" v-if="birthdayProp">
                        <date-picker view="year" :placeholder="$t('authentication_general.birthday')" id="birthday"
                                     v-model="form.birthday"
                                     auto-submit/>
                      </div>

                      <div class="p-3 col-lg-4" v-if="motherJobProp">
                        <input class="form-control " required type="text" v-model="form.mother_job"
                               :placeholder="$t('authentication_general.mother_job')">
                      </div>

                      <div v-if="fatherJobProp" class="p-3 col-lg-4">
                        <input class="form-control " type="text" required v-model="form.father_job"
                               :placeholder="$t('authentication_general.father_job')">
                      </div>

                      <div v-if="registerRequestProp" class="p-3 col-lg-6">
                        <select v-model="form.register_request" class="custom-select" name="" id="">
                          <option value="" v-t="`authentication_general.register_request`"></option>
                          <option
                              v-for="item in Object.keys($i18n.messages[$i18n.fallbackLocale]['authentication_general']['register_request_items'])">
                            {{ $t(`authentication_general.register_request_items.${item}`) }}
                          </option>
                        </select>
                      </div>

                      <div v-if="gradeSelectProp" class="p-3 col-lg-6">
                        <select v-model="form.grade_select" class="custom-select" name="" id="">
                          <option value="" v-t="`authentication_general.grade_select_box`"></option>
                          <option
                              v-for="item in Object.keys($i18n.messages[$i18n.fallbackLocale]['authentication_general']['grade_select_box_items'])">
                            {{ $t(`authentication_general.grade_select_box_items.${item}`) }}
                          </option>
                        </select>
                      </div>

                      <div v-if="roundTripServiceProp" class="py-2 col-lg-6">
                        <select required v-model="form.round_trip_service" class="custom-select" name="" id="">
                          <option value="" v-t="`authentication_general.round_trip_service`"></option>
                          <option
                              v-for="item in Object.keys($i18n.messages[$i18n.fallbackLocale]['authentication_general']['round_trip_service_items'])">
                            {{ $t(`authentication_general.round_trip_service_items.${item}`) }}
                          </option>
                        </select>
                      </div>

                      <div v-if="shiftProp" class="py-2 col-lg-6">
                        <select required v-model="form.shift" class="custom-select" name="" id="">
                          <option value="" v-t="`authentication_general.shift`"></option>
                          <option
                              v-for="item in Object.keys($i18n.messages[$i18n.fallbackLocale]['authentication_general']['shift_items'])">
                            {{ $t(`authentication_general.shift_items.${item}`) }}
                          </option>
                        </select>
                      </div>


                    </div>
                  </div>
                </div>

                <div class="col-12">
                  <div class="form-group">
                    <delivery-map1 :coordinate="order_location" @location="setOrderLocation"/>
                  </div>
                </div>


                <div class="my-3" :class="paymentSectionStyle(order)">
                  <div class="bg-white  h-100 py-1 col-lg-12 shopping-cart-box">

                    <div class="" v-if="defaultGate == ''">
                      <label v-t="'gateway.title'"></label>
                      <div class="form-row my-3">

                        <div class="form-row">
                          <m-gate-manager1 :showWalletGate="showWalletGate" v-model="form.payment_gate"
                                           @cash_on_delivery_photo="setOrderCashOnDeliveryPhoto"
                          />
                        </div>
                        <form-errors-manager class="container my-2"
                                             :validation="v$.form.payment_gate"/>


                      </div>
                    </div>


                    <div class="col-lg-12 text-center">
                      <button class="btn btn-primary rounded-pill col-4" type="submit"
                              id="shopping-card-submit-button"
                              v-t="'shopping_cart.submit_button'"></button>
                    </div>


                  </div>
                </div>


              </div>
            </form>


          </div>


          <div class="row" v-else>
            <div class="empty-cart">
              <img alt="shopping cart" v-if="EmptyCartImage !=  null" class="mt-3" :src="EmptyCartImage"/>
              <svg v-else width="150px" height="150px" viewBox="0 0 24 24" version="1.1"
                   xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <title>Shopping-cart</title>
                <g id="🖥-Landing" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g id="Artboard" transform="translate(-74.000000, -239.000000)">
                    <g id="Shopping-cart" transform="translate(74.000000, 239.000000)">
                      <rect id="Rectangle" x="0" y="0" width="24" height="24">

                      </rect>
                      <path
                          d="M2.5,3.5 L4.57364,3.5 C4.81929,3.5 5.02855,3.67844 5.06736,3.921 L6.73058,14.3158 C6.88582,15.286 7.72287,15.9998 8.70546,15.9998 L17.3957,15.9998 C18.3331,15.9998 19.1447,15.3487 19.3481,14.4337 L20.7296,8.21674 C20.8684,7.59222 20.3932,6.9998 19.7534,6.9998 L5.83997,6.9998"
                          id="Path" stroke="#0C0310" stroke-width="2" stroke-linecap="round">

                      </path>
                      <circle id="Oval" stroke="#0C0310" stroke-width="2" stroke-linecap="round"
                              cx="9.5" cy="21" r="1">

                      </circle>
                      <circle id="Oval" stroke="#0C0310" stroke-width="2" stroke-linecap="round"
                              cx="16.5" cy="21"
                              r="1">

                      </circle>
                    </g>
                  </g>
                </g>
              </svg>
              <h4 class="my-3" v-t="'shopping_cart_general.no_item'"></h4>
            </div>
          </div>
        </div>
      </template>
    </m-shopping-cart-wrapper>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {useVuelidate} from '@vuelidate/core'
import {required, maxLength} from '@vuelidate/validators'
import FormErrorsManager from "../validator/FormErrorsManager.vue";
import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import AddressForm from '../Address/Form/AddressForm'
import {productPrice, productName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import mShoppingCartWrapper from "../Wrappers/ShoppingCartWrapper";
import mCard304 from "../Product/Card/Card304";
import mShoppingCartQuantityManager1 from "../Product/ShoppingCartQuantityManager1";
import mA from '../Tags/A'
import DatePicker from "vue3-persian-datetime-picker";
import mGateManager1 from "../Gate/GateManager/GateManager1";

import DeliveryMap1 from "./DeliveryMap/DeliveryMap1.vue";

import {
  subProductImage,
  productReservationData,
  productReservationRange,
  reservationMetaTranslation
} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import mAdvanceDescription1 from "../AdvanceDescription/AdvanceDescription1.vue";
import {setSeoOnWrapper} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

export default {
  name: "ShoppingCart3",
  components: {
    mAdvanceDescription1,
    FormErrorsManager,
    mShoppingCartWrapper,
    AddressForm,
    mCard304,
    mShoppingCartQuantityManager1,
    mA,
    DatePicker,
    mGateManager1,
    DeliveryMap1,
  },
  props: {
    EmptyCartImage: {
      type: String,
      default: null
    },
    instagram: {
      default: false, type: Boolean
    },
    presenterProp: {
      default: false, type: Boolean
    },
    addressName: {
      default: false, type: Boolean
    },
    codeMeliProp: {default: false, type: Boolean},
    gradeProp: {default: false, type: Boolean},
    orientationProp: {default: false, type: Boolean},
    schoolNameProp: {default: false, type: Boolean},
    classNameProp: {default: false, type: Boolean},
    birthdayProp: {default: false, type: Boolean},
    motherJobProp: {default: false, type: Boolean},
    fatherJobProp: {default: false, type: Boolean},
    registerRequestProp: {default: false, type: Boolean},
    gradeSelectProp: {default: false, type: Boolean},
    roundTripServiceProp: {default: false, type: Boolean},
    shiftProp: {default: false, type: Boolean},
    showWalletChargeProp: {default: true, type: Boolean},
    showWalletGate: {default: true, type: Boolean},
    advanceDescriptionInputs: {default: ''},
    advanceDescription: {default: false, type: Boolean},
    defaultGate: {
      default: '',
      type: String
    },
    enableEditOrder: {default: false, type: Boolean},
  },
  setup: () => ({v$: useVuelidate()}),
  data() {
    return {
      form: {
        address: '',
        order_description: '',
        payment_gate: '',
        instagram: '',
        presenter: '',
        code_meli: '',
        grade: '',
        orientation: '',
        school_name: '',
        class_name: '',
        birthday: '',
        mother_job: '',
        father_job: '',
        register_request: '',
        grade_select: '',
        round_trip_service: '',
        shift: '',
        payment_receipt: null
      },
      order: [],
      component_addresses: [],
      order_location: null,
    }
  },
  computed: {
    ...mapGetters({
      profile: 'User/getProfile',
      isAdmin: 'User/isAdmin',
      isUserStore: "User/isUserStore"
    }),
    setWalletLinkToDashboard() {
      let userId = this.profile.id
      const dashboardLink = this.findAttributeOnSiteInfo('dashboard_link')[0]
      return `${dashboardLink}/dashboard/wallet/charge/${userId}`
    },
    profileWalletValue() {

      let profile = this.profile

      if (profile.wallet != null) {
        return profile.wallet.value
      }

      return 0
    }
  },
  validations() {
    return {
      form: {
        address: {},
        order_description: {},
        payment_gate: {required},
        instagram: {},
        presenter: {},
      },
    }

  },
  methods: {
    productReservationData,
    productReservationRange,
    reservationMetaTranslation,
    dateConverter,
    subProductImage,
    formatNumber,
    productName,
    productPrice,
    isDeliveryFree(delivery_boundary, price) {
      return parseInt(delivery_boundary) <= parseInt(price)
    },
    setAddresses(value) {
      const addresses = value[0]
      const order = value[1]
      this.component_addresses = []
      addresses.forEach(item => {
        this.component_addresses.push({text: item.name, value: item.id, default_address: item.default_address})
      })


      if (order.address != null) {
        this.form.address = order.address.id
      } else {

        if (addresses.length > 0 && order.id != undefined) {
          const selectedAddress = addresses[0].id;
          let form = {
            order: order.id,
            address_id: selectedAddress,
            description: this.form.order_description,
          };
          this.$store.dispatch("ShoppingCart/chooseAddressAndDescription", form).then(res => {
            this.$store.dispatch("ShoppingCart/userOrderUnpaid")
          })
          this.form.address = selectedAddress
        }

      }
    },
    setOrderDeliveryLocation(order) {

      let item = order.meta.find(item => {
        if (item.name == 'order_location') {
          return item
        }
      })

      if (item != undefined) {
        return item.value
      }
      return null
    },
    setOrderDescription(order) {
      this.form.order_description = order.description
      this.order = order
      this.order_location = this.setOrderDeliveryLocation(order)
    },
    orderHavePhysicalProduct(order) {
      const products = order.items
      let state = false;

      products.forEach(product => {
        if (product.product.is_digital == 0) {
          state = true;
        }
      })

      // todo create init function and put all methods which have order parameter
      if (this.birthdayProp && document.querySelector('#birthday input') != null) {
        document.querySelector('#birthday input').setAttribute('required', true)
      }

      return state
    },
    paymentSectionStyle(order) {
      if (this.orderHavePhysicalProduct(order)) {
        return 'col-lg-12';
      }
      return 'col-lg-6'
    },
    async onSubmit(order) {
      const result = await this.v$.form.$validate()
      if (!result) return
      let shoppingCardSubmitButton = document.getElementById('shopping-card-submit-button')
      shoppingCardSubmitButton.disabled = false;

      const order_id = order.id
      const gate = this.form.payment_gate

      const instagram = this.form.instagram.length > 0 ? '@' + this.form.instagram : ''
      const presenter = this.form.presenter.length > 0 ? 'معرف:' + this.form.presenter : ''
      const orderDescription = this.form.order_description != null ? this.form.order_description : '';

      const code_meli = this.codeMeliProp ? ` کدملی:  ${this.form.code_meli}` : '';
      const grade = this.gradeProp ? ` پایه: ${this.form.grade}` : '';
      const orientation = this.orientationProp ? ` رشته: ${this.form.orientation}` : '';
      const school_name = this.schoolNameProp ? ` نام مدرسه: ${this.form.school_name}` : '';
      const class_name = this.classNameProp ? ` کلاسی که ثبت نام کرده اید: ${this.form.class_name}` : '';

      let schoolForm = code_meli + grade + orientation + school_name + class_name

      const birthday = this.birthdayProp ? ` تاریخ تولد: ${this.form.birthday}` : ''
      const mother_job = this.motherJobProp ? ` شغل مادر: ${this.form.mother_job}` : ''
      const father_job = this.fatherJobProp ? ` شغل پدر: ${this.form.father_job}` : ''
      const register_request = this.registerRequestProp ? ` درخواست ثبت نام: ${this.form.register_request}` : ''
      const grade_select = this.gradeSelectProp ? ` پایه: ${this.form.grade_select}` : ''
      const round_trip_service = this.roundTripServiceProp ? ` سرویس رفت و برگشت: ${this.round_trip_service}` : ''
      const shift = this.shiftProp ? ` متقاضی ثبت نام شیفت: ${this.shift}` : ''


      let schoolForm2 = birthday + mother_job + father_job + register_request + grade_select + round_trip_service + shift;
      let orderDescriptionSummarize = orderDescription + ' ' + instagram + ' ' + presenter + ' ' + schoolForm + ' ' + schoolForm2;

      let form = {
        order: order_id,
        address_id: this.form.address,
        description: orderDescriptionSummarize,
        gate: gate
      };

      shoppingCardSubmitButton.disabled = true;

      if (this.orderHavePhysicalProduct(order)) {
        await this.$store.dispatch("ShoppingCart/chooseAddressAndDescription", form).then(res => {
          const gate = this.form.payment_gate

          let req = this.$store.dispatch("Transaction/createTransaction", {
            order: order_id,
            gate: gate,
            description: orderDescriptionSummarize,
            order_location: this.order_location,
            payment_receipt: this.form.payment_receipt,
          });

          req.then(res => {

          }).catch((error) => {
            shoppingCardSubmitButton.disabled = false;
          })


        });
      } else {
        const gate = this.form.payment_gate
        let req = await this.$store.dispatch("Transaction/createTransaction", {
          order: order_id,
          gate: gate,
          description: orderDescriptionSummarize,
          payment_receipt: this.form.payment_receipt,
        });

        req.then(res => {
          shoppingCardSubmitButton.disabled = false;
        }).catch((error) => {
          shoppingCardSubmitButton.disabled = false;
        })


      }

    },
    async createAddress(form) {
      await this.$store.dispatch('Address/createAddressWithoutState', {form}).then(async (res) => {
        await this.$store.dispatch("Address/getOrderAddressesWithoutState").then(res => {
          const data = [res.data.data.data, this.order]
          this.setAddresses(data);
          document.querySelector('#create-address .close').click()
        });

      })
    },
    async editAddress(form) {
      await this.$store.dispatch('Address/updateAddressWithoutState', form).then(async (res) => {
        await this.$store.dispatch("Address/getOrderAddressesWithoutState").then(res => {
          const data = [res.data.data.data, this.order]
          this.setAddresses(data);
          document.querySelector('#edit-address .close').click()
        });

      })
    },
    changeAddress(order) {
      let form = {
        order: order.id,
        address_id: this.form.address,
        description: this.form.order_description,
      };
      this.$store.dispatch("ShoppingCart/chooseAddressAndDescription", form).then(res => {
        this.$store.dispatch("ShoppingCart/userOrderUnpaid")
      })
    },
    reloadShoppingCart() {
      this.$store.dispatch('ShoppingCart/userOrderUnpaid')
    },
    productImage(product, subProduct) {
      const image = this.subProductImage(product, subProduct);
      if (image != undefined && image.split('/').slice(-1)[0] != 'null') {
        if (product.thumbnail != null) {
          return product.thumbnail
        }
        return image
      }
      return product.thumbnail
    },
    redirectUserToEditOrder(order) {
      let dashboardLink = findAttributeOnSiteInfo('dashboard_link')[0]
      let editDashboardLink = `${dashboardLink}/dashboard/orders/update/${order.id}`
      window.open(editDashboardLink, '_blank');
    },
    setOrderLocation(data) {
      let form = {
        delivery_location: data.toString(),
        order_id: this.order.id
      }
      this.order_location = data.toString()
      this.$store.dispatch('Delivery/storeOrderDeliveryLocation', form).then(res => {
        this.reloadShoppingCart()
      })


    },
    deliveryPriceManager(deliveryPrice) {
      if (deliveryPrice == null) {
        return "خارج از محدوده ارسال"
      }
      return this.$t('price.price', {currency: formatNumber(deliveryPrice)})
    },
    orderPriceWithoutTax(order) {
      let result = 0;
      order.items.forEach(item => {
        result += item.subtotal
      })

      return result + parseInt(order.delivery_amount)
    },
    calculateTax(order) {
      let rawPrice = this.orderPriceWithoutTax(order);
      return order.paying_amount - rawPrice
    },
    selectedAddressNotBeDefault() {
      let checker = true
      this.component_addresses.forEach((item) => {
        if (item.value == this.form.address && item.default_address == 1) {
          checker = false
        }
      })

      return checker
    },
    setOrderCashOnDeliveryPhoto(data) {
      this.form.payment_receipt = data
    }
  },
  mounted() {
    const birthdayInput = document.querySelector('#birthday input');
    if (this.birthdayProp && birthdayInput != null) { // set required for birthday when birthdayProp was true and shopping cart have item.
      document.querySelector('#birthday input').setAttribute('required', true)
    }
    if (this.defaultGate.length > 0) {
      this.form.payment_gate = this.defaultGate
    }
    setSeoOnWrapper({}, 'shopping-cart')
  }
}
</script>

<style scoped>
.empty-cart {
  font-size: 14px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.line-through {
  text-decoration: line-through;
  text-decoration-color: red;
}

.delivery-boundary-font-size {
  font-size: 13px;
}

.shopping-cart-box {
  border-radius: 25px
}

.custom-font-size {
  font-size: 15px;
}

.order-description {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.shopping-card-3-address-button i {
  height: 16px;
}
</style>
